<script>

export default {
  name: "Modal-freight-form",
  props: {
    mode: {
      type: Number,
      default: 0 // 0: add, 1: modify
    },
    title: {
      type: String,
      default: "운송편 등록"
    },
    freightInfo: {
      tyep: Object,
      default: {}  
    }
  },
  emits:[
    "close-modal",
    "add-item",
    "modify-item"
  ],
  data() {
    return {
      method      : this.freightInfo.method || "",
      freightNo   : this.freightInfo.freightNo || "",
      nation      : this.freightInfo.nation || "",  
      note        : this.freightInfo.note || "",
      departure   : this.freightInfo.departure || "",
      arrival     : this.freightInfo.arrival || "",
      status      : this.freightInfo.status || '0'
    }
  },
  methods : {

    /**
     * Title        : 운송편 추가하기
     * Status       : Actived
     * Description  : 운송편을 추가한다.
     * @returns {void}
     */
    addItem(){
      const newData = {
        method      : this.method,
        freightNo   : this.freightNo,
        nation      : this.nation,
        note        : this.note,
        departure   : this.departure,
        arrival     : this.arrival,
        status      : this.status,
      }
      this.$emit("add-item", newData)
      this.$emit("close-modal")
    },

    /**
     * Title        : 운송편 수정하기
     * Status       : Actived
     * Description  : 운송편을 수정한다.
     * @returns {void}
     */
    modifyItem(){
      const modifiedData = {
        id          : this.freightInfo.id, // Assuming the freightInfo has an id field 
        method      : this.method,
        freightNo   : this.freightNo,
        nation      : this.nation,
        note        : this.note,
        departure   : this.departure,
        arrival     : this.arrival,
        status      : this.status,
      }
      this.$emit("modify-item", modifiedData)
      this.$emit("close-modal")
    },
  },
  mounted() {
    this.$log.info("[ Modal / 운송편추가 ]")
    this.$getFreightList()
    this.$getCityList()
    this.$getCodeList("NATION")
  },
}
</script>

<template>
  <q-layout 
    container
    class="bg-white">
    
    <q-header class="bg-primary">
      <q-toolbar>
        <q-toolbar-title>{{ title }}</q-toolbar-title>
        <q-btn flat v-close-popup round icon="close" />
      </q-toolbar>
    </q-header>

    <q-footer class="bg-white text-black">
      <q-toolbar>
        <q-btn
          v-if="mode === 'add'"
          label="추가"
          class="full-width"
          color="primary"
          @click="addItem">
        </q-btn>

        <q-btn
          v-if="mode === 'modify'"
          label="수정"
          class="full-width"
          color="primary"
          @click="modifyItem">
        </q-btn>
      </q-toolbar>
    </q-footer>

    <q-page-container>
      <q-page
        padding>
        <div class="row q-gutter-md q-mb-sm">
          <div class="col">
            <q-select
              v-model="method"
              label="운송수단"
              :options="this.$store.getters.getFreightMethodList"
              behavior="menu"
              emit-value
              map-options />
          </div>
          <div class="col">
            <q-input 
              v-model="freightNo"
              :maxlength="6"
              label="운송편번호" />    
          </div>
          <div class="col">
            <q-select 
              v-model="nation" 
              :options="this.$store.getters.getNationList"
              behavior="menu"
              label="국가"
              emit-value
              map-options />
          </div>
        </div>
        <div class="row q-gutter-md q-mb-sm">
          <div class="col">
            <q-select 
              v-model="departure" 
              :options="this.$store.getters.getCityListNew"
              behavior="menu"
              label="출발지"
              emit-value
              map-options />
          </div>
          <div class="col">
            <q-select 
              v-model="arrival" 
              :options="this.$store.getters.getCityListNew"
              behavior="menu"
              label="도착지"
              emit-value
              map-options />
          </div>
        </div>
        <div class="row q-gutter-md q-mb-sm">
          <div class="col">
            <q-input 
              v-model="note"
              type="textarea"
              :maxlength="1000"
              label="설명" />    
          </div>
        </div>
        <div class="row q-gutter-md q-mb-sm">
          <div class="col">
            <q-toggle
              v-model="status"
              label="상태"
              :true-value="'0'"
              :false-value="'1'"
              checked-icon="check"
              color="green"
              unchecked-icon="clear"/>
          </div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>